import { shuffle } from 'lodash'

export function getRandomImages(images, count = 3) {
  const shuffledImages = shuffle(images)
  return shuffledImages.slice(0, count)
}
